var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"text-center text-h4"},[_vm._v("Welcome!")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }